export default __webpack_public_path__ + "static/installation-trimmed-cddb80122b9f1f9ed79c0c24ceb839e3.jpg";